import React from 'react';

import Switch from 'react-switch';
const ToggleButton = ({
  label,
  id = 'material-switch',
  setter,
  value,
  diameter = 20,
  height = 14,
  width = 34,
  disabled
}) => {
  const handleChange = (e) => {
    if (typeof setter == 'function') {
      setter(e);
    }
  };
  return (
    <label htmlFor={id}>
      {label && <span>{label}</span>}
      <Switch
        type="button"
        checked={value}
        onChange={handleChange}
        onColor="#e8eeff"
        onHandleColor="#2960ec"
        handleDiameter={diameter}
        uncheckedIcon={false}
        checkedIcon={false}
        boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
        activeBoxShadow="0px 0px 1px 5px rgba(0, 0, 0, 0.2)"
        height={height}
        width={width}
        className="react-switch"
        disabled={disabled}
        id={id}
      />
    </label>
  );
};

export default ToggleButton;
